import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router';
import useSWRMutation from 'swr/mutation';
import http from '@/Utils/HTTP/NewHttpUtils';
import useAISearchProgress from './useAISearchProgress';

export interface RetryRankingJobsRequest {
    jobIds: string[];
}

const useRetryRankingJob = () => {
    const { getAccessTokenSilently } = useAuth0();
    const { assessmentId } = useParams();
    const { mutate: mutateAiSearchProgress } = useAISearchProgress();

    return useSWRMutation(
        `recruitments/${assessmentId}/ranking-jobs/retry`,
        async (path: string, { arg }: { arg: RetryRankingJobsRequest }) => {
            await http.post({
                path,
                accessToken: await getAccessTokenSilently(),
                body: arg,
            });
        },
        {
            onSuccess: async () => {
                // When the ranking jobs are rescheduled then the search progress status changes
                // therefore, we force search progress query to get the updated values.
                await mutateAiSearchProgress();
            },
        },
    );
};

export default useRetryRankingJob;
